import { text } from 'drizzle-orm/pg-core';
import { DefaultWeightUnit, OneRepMaxFormula } from './enums';
export const settingsColumns = {
    oneRepMaxFormula: OneRepMaxFormula('one_rep_max_formula').notNull(),
    defaultCycleLabel: text('default_cycle_label').notNull(),
    defaultSessionLabel: text('default_session_label').notNull(),
    defaultWeightUnit: DefaultWeightUnit('default_weight_unit')
        .notNull()
        .default('lbs'),
};
//# sourceMappingURL=settings-columns.js.map